import React, { Component } from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

export default class Navbar extends Component {
    render() {
        const { color, height, logo, children } = this.props;
        return (
            <NavWrap color={color} height={height} >
                <Link to={'/'} >
                    <Logo src={logo} height={height} alt='Logo' />
                </Link>
                {children && <Content>{[...children]}</Content>}

            </NavWrap >
        );
    }
}

const NavWrap = styled.div`
    position: sticky;
    z-index: 3;
    top: 0;
    width: 100%;
    display: flex;
    flex-direction: row;
    ${props => props.height ? `height: ${props.height}px;` : 'height: 100px;'}
    ${props => props.color ? `background-color: ${props.color};` : 'background-color: #333'}
`;

const Logo = styled.img`
    ${props => props.height ? `height: ${props.height * 0.6}px; margin: ${props.height * 0.2}px;` : 'height: 80px margin: 10px;'}
`;

const Content = styled.div`
    display: flex;
    flex-direction: row;
`;